module.exports = __webpack_public_path__ + "media/images/city/089-moai-e6f28f8ae8b39851feb29eb4295b597f.svg";